import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/app/[country]/[lang]/error.tsx");
